import { Moment } from 'moment';
import { TipoUpload } from './enum';
import { DocumentReference } from 'firebase/firestore';
import { NotaBMF, NotaBovespa, NotaParcial } from './nota';
import ExercicioDireito from './exercicioDireito';
import Checkpoint from './checkpoint';

export default class Upload implements IUpload {
  public id!: string;
  public situacao!: string;
  public tipo?: TipoUpload;
  public nomeArquivoOriginal!: string;
  public dataUpload?: Moment;
  public nome?: string;
  public corretora?: string;
  public dataEmissao?: Moment;
  public periodo?: Periodo;
  public arquivo?: string;
  public quantidadePregoes?: number;
  public quantidadeParciais?: number;
  public novosPregoes?: number;
  public erro?: any;
  public senhaProtegida?: boolean;
  public conexao?: any;
  public incompatibilidades?: Incompatibilidade[];
  public itensImportados?: DocumentReference<
    NotaBovespa | NotaBMF | NotaParcial | ExercicioDireito | Checkpoint
  >[];

  constructor(param: IUpload) {
    Object.assign(this, param);
  }
}

export interface IUpload {
  id: string;
  situacao: string;
  tipo?: TipoUpload;
  nomeArquivoOriginal?: string;
  dataUpload?: Moment;
  nome?: string;
  corretora?: string;
  dataEmissao?: Moment;
  periodo?: Periodo;
  arquivo?: string;
  quantidadePregoes?: number;
  quantidadeParciais?: number;
  novosPregoes?: number;
  erro?: any;
  senhaProtegida?: boolean;
  conexao?: string;
  incompatibilidades?: Incompatibilidade[];
  itensImportados?: DocumentReference<
    NotaBovespa | NotaBMF | NotaParcial | ExercicioDireito | Checkpoint
  >[];
}

export interface Periodo {
  de: Moment;
  a: Moment;
}

export interface Pregao {
  dataPregao: Moment;
  operacoes: any[];
}

type Incompatibilidade = {
  erro: any;
  detalhes: string[];
};
